import { render, staticRenderFns } from "./descuentosArticulo.vue?vue&type=template&id=311b40c7&scoped=true"
import script from "./descuentosArticulo.vue?vue&type=script&lang=js"
export * from "./descuentosArticulo.vue?vue&type=script&lang=js"
import style0 from "./descuentosArticulo.vue?vue&type=style&index=0&id=311b40c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311b40c7",
  null
  
)

export default component.exports